<template>
	<div class="comp">
		<div class="grid settings comp-inner">
			<div class="grid header">
					<div class="grid sectiontitle">Reparto fatturazione</div>
					<div class="grid settings">
				<transition name="slide-fade">
					<button @click="save()" v-if="changes" class="btn green" v-loading="hotelloading"><unicon name="save" fill="#fff" /> salva modifiche</button>
				</transition>
				<button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
					</div>
				</div>

				<!-- <h3>Hai {{$store.state.ombrelloni.ombrelloni.length}} ombrelloni in spiaggia, la fattura sarebbe di {{$store.state.ombrelloni.ombrelloni.length * 0.5}}€ al mese.</h3> -->

				<div class="grid billing">

					<div class="grid box bill">
<!-- 						<div class="grid item">
							<span class="desc">Ombrelloni</span>
							<span class="count">{{$store.state.ombrelloni.ombrelloni.length}}</span>
							<span class="cost">€ 0.50</span>
							<span class="subtotal">{{$store.state.ombrelloni.ombrelloni.length * 0.5}}</span>
						</div>
						<div class="grid item">
							<span class="desc">Ombrelloni</span>
							<span class="count">{{$store.state.ombrelloni.ombrelloni.length}}</span>
							<span class="cost">€ 0.50</span>
							<span class="subtotal">{{$store.state.ombrelloni.ombrelloni.length * 0.5}}</span>
						</div> -->

						<el-table
							:data="bill"
							:summary-method="getSummaries"
							show-summary
							style="width: 100%">
							<el-table-column
								prop="desc"
								label="Descrizione"
								width="180">
								<template>
								</template>
							</el-table-column>
							<el-table-column
								prop="number"
								label="Numero"
								width="180">
							</el-table-column>
							<el-table-column
								prop="cost"
								label="Costo">
							</el-table-column>
							<el-table-column
								prop="subtotal"
								label="Calcolato">
								<template slot-scope="scope">
									€ {{scope.row.subtotal}}
								</template>
							</el-table-column>
						</el-table>

					</div>

<!-- 					<div class="grid packages box">
						<div class="grid package">
							{{total * 3}}
						</div>
						<div class="grid package">
							{{(total * 6) * 0.9}}
						</div>
						<div class="grid package">
							{{(total * 9) * 0.5}}
						</div>
					</div> -->

				</div>

		</div>
	</div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
import helper from '../Mixins/helper'
export default {
	name: 'Billing',
	mixins: [helper],
	props: {
		// hotel: Object
	},
	data () {
	return {
		changes: false,
		total: 0
	}
	},
	methods: {
		getSummaries (param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = 'Totale Fattura';
						return;
					}
					if (index === 1) {
						return;
					}
					if (index === 2) {
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums['total'] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = '€ ' + values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
					} else {
						sums[index] = 'N/A';
					}
				});
				this.total = sums['total']
				return sums;
			},
	show (section) {
		// console.log(section)
		this.$emit('open', section)
	},
	save () {
		console.log('save')
		// this.$store.dispatch('hotels/updateHotel', this.hotel)
	}
	},
	filters: {

	},
	watch: {

	},
	computed: {
		bill () {
			var items = []
			items.push({
				desc: 'Ombrelloni',
				number: this.$store.state.ombrelloni.ombrelloni.length,
				cost: '€ 0.50',
				subtotal: this.$store.state.ombrelloni.ombrelloni.length * 0.5
			})
			if (this.$store.state.hotels.activehotel.cashier) {
				items.push({
				desc: 'Calcolo Checkout',
				number: 1,
				cost: '€ 28.50',
				subtotal: 28.50
			})
			}
			return items
		}
	},
	beforeMount () {

	},
	beforeDestroy () {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
